"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableResizable = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _iconsMaterial = require("@mui/icons-material");

var _styles = require("./styles.js");

var _jsxRuntime = require("react/jsx-runtime");

var createHeaders = function createHeaders(headers) {
  return headers.map(function (item) {
    return {
      text: item,
      ref: (0, _react.useRef)()
    };
  });
};
/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/resizable-tables-with-react-and-css-grid
 */


var TableResizable = function TableResizable(props) {
  var gridTemplateColumns = props.gridTemplateColumns,
      headers = props.headers,
      minCellWidth = props.minCellWidth,
      tableContent = props.tableContent,
      withResetSizeButton = props.withResetSizeButton; // const [tableHeight, setTableHeight] = useState("auto");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var tableElement = (0, _react.useRef)(null);
  var columns = createHeaders(headers); // useEffect(() => {
  //   setTableHeight(tableElement.current.offsetHeight);
  // }, []);

  var mouseDown = function mouseDown(index) {
    return setActiveIndex(index);
  };

  var mouseMove = (0, _react.useCallback)(function (e) {
    var gridColumns = columns.map(function (col, i) {
      if (i === activeIndex) {
        var width = e.clientX - col.ref.current.offsetLeft;
        if (width >= minCellWidth) return "".concat(width, "px");
      }

      return "".concat(col.ref.current.offsetWidth, "px");
    });
    var gridTemplateColumns = "".concat(gridColumns.join(" "));
    tableElement.current.style.gridTemplateColumns = gridTemplateColumns;
  }, [activeIndex, columns, minCellWidth]);
  var removeListeners = (0, _react.useCallback)(function () {
    window.removeEventListener("mousemove", mouseMove);
    window.removeEventListener("mouseup", removeListeners);
  }, [mouseMove]);
  var mouseUp = (0, _react.useCallback)(function () {
    setActiveIndex(null);
    removeListeners();
  }, [setActiveIndex, removeListeners]);
  (0, _react.useEffect)(function () {
    if (activeIndex > -1) {
      window.addEventListener("mousemove", mouseMove);
      window.addEventListener("mouseup", mouseUp);
    }

    return function () {
      return removeListeners();
    };
  }, [activeIndex, mouseMove, mouseUp, removeListeners]);

  var resetTableCells = function resetTableCells() {
    tableElement.current.style.gridTemplateColumns = "";
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    gridTemplateColumns: gridTemplateColumns,
    totalColumns: columns === null || columns === void 0 ? void 0 : columns.length,
    totalRows: tableContent === null || tableContent === void 0 ? void 0 : tableContent.length,
    children: [withResetSizeButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "reset-button",
      onClick: resetTableCells,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.RestartAlt, {
        sx: {
          fontSize: 18
        }
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "table-wrapper",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
        className: "resizeable-table",
        ref: tableElement,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
            children: columns === null || columns === void 0 ? void 0 : columns.map(function (_ref, i) {
              var ref = _ref.ref,
                  text = _ref.text;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("th", {
                ref: ref,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: text
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    height: "50px"
                    /* tableHeight */

                  },
                  onMouseDown: function onMouseDown() {
                    return mouseDown(i);
                  },
                  className: "resize-handle ".concat(activeIndex === i ? "active" : "idle")
                })]
              }, i);
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
          children: tableContent.map(function (row) {
            var _row$columns;

            return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
              children: row === null || row === void 0 ? void 0 : (_row$columns = row.columns) === null || _row$columns === void 0 ? void 0 : _row$columns.map(function (column, indexColumn) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
                  className: (0, _typeof2.default)(column) === "object" ? "noOverflow" : "",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: column
                  })
                }, "".concat(row.key, "-").concat(indexColumn));
              })
            }, row.key);
          })
        })]
      })
    })]
  });
};

exports.TableResizable = TableResizable;